export const generateID = (type) => {
  return `${type}-${Math.random().toString(36).substring(2, 15)}`;
};
